export default __webpack_public_path__ + "static/media/accessFolder.9e4eed3a.svg";